import { routes } from './app.routes';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import localeEs from '@angular/common/locales/es';
import localePtBr from '@angular/common/locales/pt';
import localeEsCL from '@angular/common/locales/es-CL';
import { ConfirmationService, MessageService } from 'primeng/api';
import { registerLocaleData, IMAGE_CONFIG } from '@angular/common';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { configLanguage } from '@shared/constants/config-primeng.constant';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { APP_INITIALIZER, ApplicationConfig, inject, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { PermissionRefreshService } from '@shared/services/permission-refresh.service';

registerLocaleData(localeEs);
registerLocaleData(localeEsCL);
registerLocaleData(localePtBr);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.dark' } } }, configLanguage),
    { provide: IMAGE_CONFIG, useValue: { disableImageSizeWarning: true } },
    MessageService,
    ConfirmationService,
    // Inicializa PermissionRefreshService en el arranque para activar listeners de runtime.
    { provide: APP_INITIALIZER, useFactory: () => { inject(PermissionRefreshService); return () => {}; }, multi: true },
  ]
};
